import React from 'react';

const Information = '/icons/information.png';
import './RequiredItems.style.scss';

export const RequiredItems = () => {
  return (
    <div className="required-items">
      <div className="required-items__content">
        <div className="required-items__group">
          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">
                Dados bancários do seu estabelecimento;
              </h3>
              <p className="required-items__text">
                (É necessário que seja uma{''}
                <span className="required-items__text--bold">
                  conta corrente vinculada ao CNPJ
                </span>
                {''}, ok?)
              </p>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">
                O CNAE do seu estabelecimento;
              </h3>
              <p className="required-items__text">
                (se não souber, a informação tá lá no seu cartão CNPJ!)
              </p>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">
                Informações da sua maquininha;
              </h3>
              <p className="required-items__text">
                (a <strong>marca da maquininha</strong> que pretende habilitar{' '}
                <strong>e o código de afiliação</strong>)
              </p>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">
                O CNPJ do seu estabelecimento;
              </h3>
            </div>
          </div>

          <div className="required-items__group-content required-items--relative">
            <div className="required-items__image">
              <img src={Information} alt="Imagem de animação" />
            </div>
            <div className="required-items__info">
              <h3 className="required-items__title">Seu CPF;</h3>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">Seu e-mail;</h3>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title required-items--width-calc">
                A razão social do seu estabelecimento;
              </h3>
              <p className="required-items__text">
                (igual consta no seu cartão CNPJ)
              </p>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">
                O nome fantasia do seu estabelecimento;
              </h3>
              <p className="required-items__text">
                (aquele nome que vai na sua fachada)
              </p>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">Número do telefone;</h3>
              <p className="required-items__text">(não esquece do DDD!)</p>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">Seus endereços;</h3>
              <p className="required-items__text">
                (o da loja, de correspondência e, se houver, do escritório)
              </p>
            </div>
          </div>

          <div className="required-items__group-content">
            <div className="required-items__info">
              <h3 className="required-items__title">
                Nome completo e data de nascimento.
              </h3>
              <p className="required-items__text">
                {'('}
                <span className="required-items__text--bold">
                  tanto do proprietário como dos sócios
                </span>{' '}
                – caso seja uma sociedade)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
